(function () {
  var WIDGET_SELECTOR = '.embeddable-DyHr4Np5U1';
  var STYLE_ID = 'hwi-schedule-embed-overrides';

  function getRemMultiplier() {
    var htmlFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (!htmlFontSize || htmlFontSize <= 0) return 1;
    return 16 / htmlFontSize;
  }

  function remAt16(px) {
    return ((px / 16) * getRemMultiplier()).toFixed(4) + 'rem';
  }

  function buildShadowOverrides() {
    var m = getRemMultiplier();

    return `
    :host {
      --spacing: ${(0.25 * m).toFixed(4)}rem;
      --text-xs: ${remAt16(12)};
      --text-sm: ${remAt16(14)};
      --text-base: ${remAt16(16)};
      --text-lg: ${remAt16(18)};
      --text-xl: ${remAt16(20)};
      --text-3xl: ${remAt16(30)};
      --text-4xl: ${remAt16(36)};

      --primary: 277, 47%, 37%;
      --primary-foreground: 0, 0%, 100%;
      --secondary: 226, 49%, 32%;
      --secondary-foreground: 0, 0%, 100%;
      --muted: 270, 100%, 97%;
      --muted-foreground: 277, 47%, 37%;
      --success: 220, 10%, 50%;
      --success-foreground: 220, 10%, 50%;
      --background: 0, 0%, 100%;
      --foreground: 0, 0%, 13%;
      --border: 0, 0%, 90%;
      --radius: 9999px;
    }

    .embeddable-widget {
      font-family: Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;
      font-size: ${remAt16(16)};
      line-height: 1.5;
      min-height: 0 !important;
      padding: ${remAt16(32)} ${remAt16(40)} !important;
      border-radius: 16px;
    }

    [data-element-id="header-subtitle"] {
      display: none;
    }

    [data-element-id="header-title"] {
      font-size: clamp(${remAt16(24)}, 2.5vw, ${remAt16(32)}) !important;
      font-weight: 700 !important;
      color: #5d348b !important;
      margin-bottom: ${remAt16(24)} !important;
      letter-spacing: 0;
    }

    [data-element-id="header"] {
      margin-bottom: ${remAt16(32)} !important;
    }

    [data-element-id="location-filter-container"],
    [data-element-id="age-filter-container"] {
      gap: ${remAt16(12)} !important;
    }

    [data-element-id="location-filter-button"],
    [data-element-id="age-filter-button"] {
      border-radius: 9999px !important;
      padding: ${remAt16(8)} ${remAt16(20)} !important;
      font-size: ${remAt16(14)} !important;
      font-weight: 600 !important;
      border: none !important;
      transition: background-color 0.2s ease, color 0.2s ease;
    }

    [data-element-id="location-filter-button"].hwi-filter--inactive,
    [data-element-id="age-filter-button"].hwi-filter--inactive {
      background-color: transparent !important;
      color: #5d348b !important;
    }

    [data-element-id="location-filter-button"].hwi-filter--inactive:hover,
    [data-element-id="age-filter-button"].hwi-filter--inactive:hover {
      background-color: #f4efff !important;
    }

    [data-element-id="location-filter-button"].hwi-filter--active {
      background-color: #5d348b !important;
      color: #ffffff !important;
    }

    [data-element-id="age-filter-button"].hwi-filter--active {
      background-color: #293d73 !important;
      color: #ffffff !important;
    }

    [data-element-id="table-header"] {
      background-color: #f4efff !important;
    }

    [data-element-id="table-header"] th,
    table thead th {
      background-color: #f4efff !important;
      color: #6b5a7d !important;
      font-size: ${remAt16(12)} !important;
      font-weight: 600 !important;
      text-transform: uppercase;
      letter-spacing: 0.06em;
      padding: ${remAt16(16)} ${remAt16(20)} !important;
      border-color: #ebe4f5 !important;
      white-space: nowrap;
    }

    table td {
      font-size: ${remAt16(15)};
      line-height: 1.5;
      padding: ${remAt16(18)} ${remAt16(20)} !important;
      border-color: #ebe4f5 !important;
      vertical-align: middle;
    }

    tr[data-element-id="table-row"] {
      background-color: #ffffff !important;
    }

    tr[data-element-id="table-row"]:hover {
      background-color: #faf8ff !important;
    }

    [data-element-id="class-title"] {
      font-weight: 700 !important;
      color: hsl(var(--foreground)) !important;
      font-size: ${remAt16(15)} !important;
    }

    [data-element-id="status-available"] {
      color: #808080 !important;
      font-style: normal !important;
      font-weight: 400 !important;
      font-size: ${remAt16(14)} !important;
    }

    [data-element-id="status-full"] {
      font-size: ${remAt16(14)} !important;
    }

    [data-element-id="view-details-button"] {
      color: #0087fe !important;
      font-weight: 600 !important;
      font-size: ${remAt16(15)} !important;
      background: none !important;
      padding: 0 !important;
    }

    [data-element-id="view-details-button"]:hover {
      color: #0066cc !important;
      text-decoration: underline;
    }

    .mb-6.space-y-4 {
      margin-bottom: ${remAt16(32)} !important;
    }
  `;
  }

  function isLocationFilterActive(btn) {
    return btn.className.indexOf('--primary-foreground') !== -1;
  }

  function isAgeFilterActive(btn) {
    return btn.className.indexOf('--secondary-foreground') !== -1;
  }

  function enhanceFilterButtons(root) {
    root.querySelectorAll('[data-element-id="location-filter-button"]').forEach(function (btn) {
      var active = isLocationFilterActive(btn);
      btn.classList.toggle('hwi-filter--active', active);
      btn.classList.toggle('hwi-filter--inactive', !active);
    });

    root.querySelectorAll('[data-element-id="age-filter-button"]').forEach(function (btn) {
      var active = isAgeFilterActive(btn);
      btn.classList.toggle('hwi-filter--active', active);
      btn.classList.toggle('hwi-filter--inactive', !active);
    });
  }

  var observedRoots = new WeakSet();

  function observeShadowRoot(root) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);

    new MutationObserver(function () {
      enhanceFilterButtons(root);
    }).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function injectStyles(host) {
    var root = host.shadowRoot;
    if (!root) return;

    var style = root.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      root.appendChild(style);
    }

    style.textContent = buildShadowOverrides();
    enhanceFilterButtons(root);
    observeShadowRoot(root);
  }

  function enhanceWidgets() {
    document.querySelectorAll(WIDGET_SELECTOR).forEach(injectStyles);
  }

  enhanceWidgets();
  document.addEventListener('DOMContentLoaded', enhanceWidgets);
  window.addEventListener('load', enhanceWidgets);
  document.addEventListener('shopify:section:load', enhanceWidgets);

  new MutationObserver(enhanceWidgets).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
